const CTX_BASE = '';
const APP_BASE = `${CTX_BASE}/:cnum`;

export const getRoute = (route: string, params: {[key: string]: string}): string => {
    let path = route;

    Object.entries(params)
        .forEach(([key, value]): void => {
            path = path.replace(`:${key}`, value);
        });

    return path;
};

export const routes = {
    base: CTX_BASE,
    any: '*',
    oidc: `${CTX_BASE}/oidc`,
    tn: `${CTX_BASE}/tn/:cnum(C\\d{5})`,
    app: {
        base: APP_BASE,
        logout: `${APP_BASE}/logout`,
    },
    users: {
        base: `${APP_BASE}/admin/users`,
        roles: {
            base: `${APP_BASE}/admin/users/roles`,
            confirm: `${APP_BASE}/admin/users/roles/confirm`,
            results: `${APP_BASE}/admin/users/roles/results`,
            selectRole: `${APP_BASE}/admin/users/roles/select-role`,
            selectUsers: `${APP_BASE}/admin/users/roles/select-users`,
            specifyConditions: `${APP_BASE}/admin/users/roles/specify-conditions`,
            step: `${APP_BASE}/admin/users/roles/:step?`,
        },
    },
};

export default routes;
